import { getRandomUUID } from "../Token";
import {
  getAccountDetails,
  getAccountFeaturesEndpoint,
  getInviteUserLoginEndPoint,
  invalidateTokenEndpoint,
  tscoreLogoutEndpoint,
  uploadErrorLogs,
  validateJWTEndpoint,
} from "../configuration";
import axiosInstance from "../global/axiosInterceptor";
import { HEADER_TRANSACTION_ID } from "../global/constants/apiConstants";

export const deleteItem = async (endPoint, body = {}) => {
  try {
    const deleteResponse = await axiosInstance.post(endPoint, body);
    return deleteResponse;
  } catch (error) {
    console.error("Delete Failed", error);
    return error.response;
  }
};

//Updated logic for Invite User flow login - Staging/QA and DEV
export const tokenApi = async (selectedAccount, grantType, refreshToken) => {
  const response = await fetch(getInviteUserLoginEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Transaction-ID": getRandomUUID(),
    },
    body: JSON.stringify({
      username: selectedAccount.userName,
      password: selectedAccount.password,
      grantType: grantType,
      refreshToken: refreshToken,
    }),
  });
  return await response.json();
};

export const accountDetailsApi = async (sessionToken) => {
  try {
    const resp = await axiosInstance.get(getAccountDetails());
    const data = resp.data;
    return data;
  } catch (error) {
    console.error("Error in getting account details", error);
    throw new Error("Failed to get account details.");
  }
};

export const accountFeaturesApi = async (userId, accountname) => {
  try {
    const resp = await axiosInstance.post(getAccountFeaturesEndpoint(), { userId, accountname });
    return resp.data;
  } catch (error) {
    console.error("Error fetching account features", error);
    return { isNluEnabled: false };
  }
};

export const patchAccountDetails = async ({ activeSession, body }) => {
  try {
    const resp = await axiosInstance.patch(getAccountDetails(), body);
    const data = resp.data;
    return data;
  } catch (error) {
    console.error("Error in getting account details", error);
    throw new Error("Failed to get account details.");
  }
};

//OIDC end-point validation call - JWT validation
export const validateSessionApi = async (activeSession) => {
  try {
    // Safe parsing check
    let parsed = null;
    if (activeSession) {
      try {
        parsed = JSON.parse(activeSession);
      } catch {
        throw new Error("Invalid session format");
      }
    }

    // Prevent destructuring crash if parsed resulted in null/falsy
    const { sessionToken: token, isRedisMode } = parsed || {};

    // Clean, declarative options configuration
    const fetchOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token && { "Authorization": `Bearer ${token}` }), // Add auth header conditionally
      },
    };

    const resp = await fetch(validateJWTEndpoint(), fetchOptions);
    const rawBody = await resp.text();

    if (!resp.ok) {
      throw new Error(`HTTP error! status: ${resp.status}`);
    }

    try {
      return JSON.parse(rawBody);
    } catch {
      throw new Error(`Invalid JSON response! status: ${resp.status}`);
    }
  } catch (error) {
    console.error("Error in validating token", error);
    throw error;
  }
};

export const invalidateTokenApi = async (activeSession) => {
  try {
    const formData = new URLSearchParams();

    // Only send id_token if available (legacy mode)
    // Redis mode: backend will read id_token from session
    if (activeSession?.idToken) {
      formData.append("id_token_hint", activeSession.idToken);
    }

    // Fix double slash: remove trailing slash from base URL if present
    const baseUrl = (window.REACT_APP_BASE_URL || "").replace(/\/$/, "");
    formData.append(
      "post_logout_redirect_uri",
      baseUrl + "/login"
    );

    const response = await axiosInstance.post(
      invalidateTokenEndpoint(),
      formData.toString(),
      { isFormUrlEncoded: true }
    );
    if (response.status !== 200) {
      // Log error but return 200 to allow client cleanup
      console.error("Server invalidation failed with status:", response.status);
    }
    return 200; // Always return 200 to allow client cleanup
  } catch (error) {
    // Don't throw - return 200 to guarantee client cleanup proceeds
    console.error("Error in invalidating token", error);
    return 200; // Always return 200 to allow client cleanup
  }
};

export const uploadErrorLogsApi = async (body) => {
  try {
    const transactionId = body.transactionId;
    delete body.transactionId;
    const resp = await axiosInstance.post(uploadErrorLogs(), body, {
      headers: { [HEADER_TRANSACTION_ID]: transactionId }
    });
    const data = resp.data;
    return data;
  } catch (error) {
    console.error("Error in uploading error logs", error);
  }
};
